import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-json-view',
  templateUrl: './json-view.component.html',
  styleUrls: ['./json-view.component.sass'],
})
export class JsonViewComponent implements OnInit {
  @Input() data: Array<{ type: string; content: any }>;
  @Input() forPrint: boolean;

  constructor() {}

  ngOnInit() {}

  tableLayout(block) {
    if (block.type === 'table' && block.content.hasOwnProperty('size')) {
      return 'fixed';
    } else {
      return 'auto';
    }
  }

  rowHeight(index: number, block) {
    if (
      block.type === 'table' &&
      block.content.hasOwnProperty('size') &&
      block.content.size.hasOwnProperty('rows')
    ) {
      return block.content.size.rows[index];
    } else {
      return 2;
    }
  }

  prop(obj, name, defaultValue) {
    if (obj.hasOwnProperty(name)) {
      return obj[name];
    } else {
      return defaultValue;
    }
  }

  formatValue(obj) {
    if (obj.hasOwnProperty('format')) {
      switch (obj.format) {
        case 'currencyCLP':
          if (obj.value) {
            return `$ ${new DecimalPipe('es-CL').transform(obj.value)}`;
          }
          return '';
        case 'percentage':
          if (obj.value) {
            return `${new DecimalPipe('es-CL').transform(obj.value * 100)}%`;
          }
          return '';
        case 'decimal':
          if (obj.value || obj.value === 0) {
            return `${new DecimalPipe('es-CL').transform(obj.value)}`;
          }
          return '';
        default:
          break;
      }
    }

    if (obj.value || obj.value === 0) {
      return obj.value;
    }
    return '';
  }

  isArray(obj) {
    return Array.isArray(obj);
  }
}
